export default {
  // rev
  // 0 : β版
  // 1 : 公開版
  Revision: 1,

  // meta
  Meta: [
    {'http-equiv': 'X-UA-Compatible', content: 'IE=edge'},
    {name: 'viewport', content: 'width=device-width,initial-scale=1.0'}
  ],
  // サイト情報
  SiteInfo: {
    name: 'ささえi コミュニティ',
    title: 'ささえi コミュニティ管理画面'
  },

  // フォーム新規登録時のハッシュ
  RegisterHash: '-',
  // リダイレクトの遅延
  RedirectDelay: 2000,

  // スクリーン
  Screen: {
    SP: 560,
    TB: 960
  },

  // 空の要素の表示
  BlankValue: '--',

  // アップロード可能なファイルサイズの上限
  MaxUploadFileSize: 20000000,
  MaxUploadImageWidth: 1280,
  MaxUploadImageHeight: 720,

  // テーブルオプション
  TableOptions: {
    perPage: {
      view: 20,
      modal: 20
    },
    perPageValues: [],
    // perPageValues: [20, 50],
    pagination: {
      edge: false,
      chunk: 10
    },
    getTexts (label) {
      console.log(label);
      return {
        count: '{count}件中{from}～{to}件を表示|{count}件|1件',
        noResults: label + 'はありません。',
        limit: '表示件数',
        page: 'ページ'
      }
    }
  },
  TablePerPageInitial: 30,
  TablePerPage: [10, 30, 50, 100],

  // ユーザー権限
  // -----------
  //   1 : システム管理者
  //   2 : サービス運用担当者
  //   4 : 外部連携CMS担当者
  UserRole: [
    {
      code: 'admin',
      label: 'システム管理者',
      value: 1
    },
    {
      code: 'operator',
      label: 'サービス管理者',
      value: 2
    },
    {
      code: 'external',
      label: '運用担当者',
      value: 4
    }
  ],

  // ファイルアップロードの許可拡張子
  // Extensions: {
  //   image: [
  //     'gif',
  //     'jpg',
  //     'jpeg',
  //     'png',
  //     'tif'
  //   ],
  //   document: [
  //     'ppt',
  //     'pptx',
  //     'xls',
  //     'xlsx',
  //     'doc',
  //     'docx',
  //     'pdf'
  //   ]
  // },

  // ステータス
  Status: [
    {value: 0, label: '無効', index: 2},
    {value: 1, label: '有効', index: 1}
  ],

  // 設定時間
  Hours: [
    {value: '00', label: '00'},
    {value: '01', label: '01'},
    {value: '02', label: '02'},
    {value: '03', label: '03'},
    {value: '04', label: '04'},
    {value: '05', label: '05'},
    {value: '06', label: '06'},
    {value: '07', label: '07'},
    {value: '08', label: '08'},
    {value: '09', label: '09'},
    {value: '10', label: '10'},
    {value: '11', label: '11'},
    {value: '12', label: '12'},
    {value: '13', label: '13'},
    {value: '14', label: '14'},
    {value: '15', label: '15'},
    {value: '16', label: '16'},
    {value: '17', label: '17'},
    {value: '18', label: '18'},
    {value: '19', label: '19'},
    {value: '20', label: '20'},
    {value: '21', label: '21'},
    {value: '22', label: '22'},
    {value: '23', label: '23'}
  ],
  Minutes: [
    {value: '00', label: '00'},
    {value: '05', label: '05'},
    {value: '10', label: '10'},
    {value: '15', label: '15'},
    {value: '20', label: '20'},
    {value: '25', label: '25'},
    {value: '30', label: '30'},
    {value: '35', label: '35'},
    {value: '40', label: '40'},
    {value: '45', label: '45'},
    {value: '50', label: '50'},
    {value: '55', label: '55'}
  ],

  // 検索タイプ
  SearchMode: [
    {value: 0, label: 'AND'},
    {value: 1, label: 'OR'}
  ],



  /***************
   * サービス管理
   */
  Service: {
    /**
     * 配信期間設定
     */
    // 配信頻度
    DeleiveryFrequency: [
      {value: 0, label: '全て'},
      {value: 1, label: '1回のみ'},
      {value: 2, label: '繰り返し'}
    ],
    // 配信先
    DeliveryTarget: [
      {value: 0, label: '全て'},
      {value: 1, label: '全ロケーション'},
      {value: 2, label: '属性'},
      {value: 3, label: '個別'}
    ],
    /**
     * 属性設定
     */
    // 配信設定
    AttributeDeliverySetting: [
      {value: false, label: 'なし', index: 2},
      {value: true, label: 'あり', index: 1}
    ],
    /**
     * 機能設定
     */
    // 対応キー設定
    OvertakeAssignedKey: [
      {value: 1, label: 'option1'},
      {value: 2, label: 'option2'},
      {value: 3, label: 'option3'}
    ],
    VideoCallCameraEnabled: [
      { value: true, label: "ON" },
      { value: false, label: "OFF" }
    ],
    VideoCallCameraForcedOff: [
      {value: 1, label: "ON"},
      {value: 2, label: "OFF"},
      {value: 3, label: "強制OFF"}
    ],
    VideoCallVolume: [
      { value: 0, label: "ユーザ設定" },
      { value: 1, label: "最大音量" }
    ],
    VideoCallAutoEndTime: [
      { value: 1, label: "あり" },
      { value: 0, label: "なし" }
    ],
    VideoCallAutoEndTimeInterval: {
      min: 300,
      max: 6000
    },
    // 202305 機能選択に「見守り未回答通知機能」を追加 ST
    // 見守り未回答通知設定
    NoReplyNotificationEnabled: [
      {value: false, label: 'なし', index: 5},
      {value: false, label: '見守り通知端末', index: 4},
      {value: false, label: '見守りbot', index: 3},
      {value: false, label: 'メール', index: 2},
      {value: true, label: 'あり', index: 1}
    ],
    // 202305 機能選択に「見守り未回答通知機能」を追加 ED
    // 見守り回答通知設定
    ReplyNotificationEnabled: [
      {value: false, label: 'なし', index: 5},
      {value: false, label: '見守り通知端末', index: 4},
      {value: false, label: '見守りbot', index: 3},
      {value: false, label: 'メール', index: 2},
      {value: true, label: 'あり', index: 1}
    ],
    // リンクデータ選択
    LinkSourceType: [
      {value: 0, label: 'WEBサイト'},
      {value: 1, label: 'PDFファイル'},
      {value: 2, label: 'アプリ起動'}
    ],
    // ボタン選択処理
    ButtonAction: [
      {value: 1, label: 'ホーム画面表示'},
      {value: 2, label: 'PDFファイル表示'},
      {value: 3, label: 'WEBサイト表示'},
      {value: 4, label: '画面遷移'}
    ],
    /**
     * dropbox設定
     */
    DropboxDataKbn: [
      {value: 0, label: '画像'},
      {value: 1, label: '動画'},
      {value: 2, label: 'PDF'},
      {value: 3, label: 'スライドショー'}
    ],
  },



  /***************
   * サービスコンテンツ管理
   */
  ServiceContents: {
    // 画面方向
    ScreenOrientation: [
      {value: 0, label: '横'},
      {value: 1, label: '縦'}
    ],
    // 背景パベル有無
    BgPanel: [
      {value: 0, label: 'なし', index: 1},
      {value: 1, label: 'あり', index: 0}
    ],
    // 背景パベル有無
    BgSourceType: [
      {value: 0, label: 'ファイル選択'},
      {value: 1, label: 'Dropbox連携'}
    ],
    // Dropboxファイル種別
    DropboxFileType: [
      {value: 0, label: '画像'},
      {value: 1, label: '動画'},
      {value: 2, label: 'PDF'},
      {value: 3, label: 'スライドショー'}
    ],
    // ディスプレイの画面消灯の設定
    ScreenOffTime: [
      {value: 15, label: '15秒'},
      {value: 30, label: '30秒'},
      {value: 60, label: '1分'},
      {value: 120, label: '2分'},
      {value: 180, label: '3分'},
      {value: 240, label: '4分'},
      {value: 300, label: '5分'},
      {value: 600, label: '10分'},
      {value: 1800, label: '30分'},
      {value: -1, label: '消灯しない'},
    ],

    // ボタン設定 : 選択時動作
    ButtonAction: [
      {value: 0, label: '画面遷移'},
      {value: 1, label: 'サイト表示'},
      {value: 2, label: 'ローカルファイル表示'},
      {value: 3, label: 'DropBox連携'},
      {value: 4, label: 'アプリ起動'},
      {value: 5, label: '一つ前の画面へ戻る'}
    ],
    // ボタン設定 : 表示設定
    ButtonDisplayMode: [
      {value: 0, label: '全ロケーション表示'},
      {value: 1, label: '管理者モード'},
      {value: 2, label: 'WiFi使用時'},
      {value: 3, label: '指定属性対象'},
    ],
    // ボタン設定 : バッジ利用
    ButtonBadgeUse: [
      {value: 0, label: 'なし', index: 1},
      {value: 1, label: 'あり', index: 0}
    ],
    // ボタン設定 : 表示条件
    ButtonBadgeDIsplayCondition: [
      {value: 0, label: '既読処理'},
      {value: 1, label: '新着処理'}
    ],
    // ビューワーモード設定 : 表示条件
    ViewerModeUse: [
      {value: 0, label: 'なし', index: 1},
      {value: 1, label: 'あり', index: 0}
    ],
    // ビューワーモード設定 : お天気コンテンツ表示フラグ
    WeatherContentsShow: [
      {value: 0, label: 'なし', index: 1},
      {value: 1, label: 'あり', index: 0}
    ],
    // ビューワーモード設定 : コンテンツ表示時間
    WeatherContentsDisplayInterval: [
      {value: 10, label: '10'},
      {value: 15, label: '15'},
      {value: 20, label: '20'},
      {value: 25, label: '25'},
      {value: 30, label: '30'}
    ],
    // スクリーンセーバー設定 : スクリーンセーバー利用
    ScreenSaverUse: [
      {value: 0, label: 'なし', index: 1},
      {value: 1, label: 'あり', index: 0}
    ],
    // スクリーンセーバー設定 : データ設定
    ScreenSaverData: [
      {value: 0, label: 'ビューワーモード',},
      {value: 1, label: 'DropBox連携',}
    ],
    // ライブカメラ設定 : スクリーンセーバー利用
    LiveCameraUse: [
      {value: 0, label: 'なし', index: 1},
      {value: 1, label: 'あり', index: 0}
    ],
    // デザイン設定 : アイコン設定
    DesignIconMode: [
      {value: 0, label: 'ライトモード',},
      {value: 1, label: 'ダークモード',}
    ],
    // デザイン設定 : ボタン角丸設定角丸利用
    ButtonRoundCorner: [
      {value: 0, label: 'なし', index: 1},
      {value: 1, label: 'あり', index: 0}
    ],
    // デザイン設定 : バッヂ角丸設定角丸利用
    BadgeRoundCorner: [
      {value: 0, label: 'なし', index: 1},
      {value: 1, label: 'あり', index: 0}
    ],
    // お知らせ受信時音声設定 : お知らせ受信時音声設定(ジングル音利用)
    NoticeJingleUse: [
      {value: 0, label: 'なし', index: 1},
      {value: 1, label: 'あり', index: 0}
    ],
    // お知らせ受信時音声設定 : お知らせ受信時音声設定(音声メッセージ利用)
    NoticeVoiceMessageUse: [
      {value: 0, label: 'なし', index: 1},
      {value: 1, label: 'あり', index: 0}
    ],
    // キーアサイン設定 : キーコード
    KeyCode: [
      {value: 8, label: 'ボタン1'},
      {value: 9, label: 'ボタン2'},
      {value: 10, label: 'ボタン3'},
    ],
    // キーアサイン設定 : 挙動
    KeyActionType: [
      {value: 0, label: '御用聞きモードON'},
      {value: 1, label: 'アプリ起動'},
      {value: 2, label: 'サイト表示'},
      {value: 3, label: '画面遷移'},
      {value: 4, label: '御用聞きモードOFF'}
    ],
  },



  /***************
   * 画面別設定
   */
  ScreenSetting: {
    // ホーム画面設定
    HomeScreen: [
      {value: 0, label: 'なし', index: 1},
      {value: 1, label: 'あり', index: 0}
    ],
    // 公開設定
    Released: [
      {value: 0, label: '無効', index: 1},
      {value: 1, label: '有効', index: 0}
    ],

    // スライドショー設定 : デフォルトフォーカス設定
    DefaultFocusedFlg: [
      {value: 0, label: 'No', index: 1},
      {value: 1, label: 'Yes', index: 0}
    ],
    // スライドショー設定 : ドロップボックス利用目的
    DropBoxUseType: [
      {value: 1, label: 'スライドショー用'},
      {value: 2, label: '広報用'},
      {value: 3, label: 'カレンダー用'}
    ],
    // リストボタン設定 : リストタイプ
    ListType: [
      {value: 1, label: 'お知らせ'},
      {value: 2, label: 'RSS'}
    ],
    // リストボタン設定 : お知らせ配信属性対応
    NoticeDeliveryAttribute: [
      {value: 1, label: '全て'},
      {value: 2, label: '全配信のみ'},
      {value: 3, label: '属性配信のみ'}
    ],
    // ボタン設定 : ボタン有効設定フラグ
    ButtonEnabled: [
      {value: true, label: '有効'},
      {value: false, label: '無効'}
    ],
  },



  /***************
   *サービスコンテンツ適用設定
   */
  ContentsApply: {
    DeliveryToKbn: [
      {value: 0, label: '全配信'},
      {value: 1, label: '属性配信'},
      {value: 2, label: '個別配信'}
    ]
  },



  /***************
   * ファイル管理
   */
  File: {
    ContentType: [
      {value: 'image', label: '画像ファイル', index: 0},
      {value: 'video', label: '動画ファイル', index: 1},
      {value: 'audio', label: '音声ファイル', index: 2},
      {value: 'pdf', label: 'PDFファイル', index: 3},
      {value: 'txt', label: 'テキストファイル', index: 4}
    ]
  },



  /***************
   * Bot管理
   */
  Bot: {
    BotKbn: [
      {value: 1, label: '見守り'},
      {value: 2, label: '御用聞き'},
      {value: 9, label: 'その他'},
    ]
  },



  /***************
   * マスタ管理
   */
  Mst: {
    // 202305 機能選択に「見守り未回答通知機能」を追加 ST
    // 機能マスタ : 配信タイプ
    FunctionDeliveryType: {
      follow: '見守り機能',
      followNoReply: 'followNoReply'
    },
    // 202305 機能選択に「見守り未回答通知機能」を追加 ED
    // 配信タイプマスタ : 配信タイプ名
    DeliveryType: [
      {private_notice: 'private_notice'}
    ],
    // 配信タイプマスタ : プライオリティ
    DeliveryPriorityKbn: [
      {value: 1, label: 'notice'},
      {value: 2, label: 'alert'}
    ],
    // 配信タイプマスタ : CMS表示
    CmsDisplayKbn: [
      {value: 0, label: '非表示'},
      {value: 1, label: '表示'}
    ],
    // 配信タイプマスタ : LED設定
    LedDisplayKbn: [
      {value: 1, label: '開封時消灯', index: 1},
      {value: 2, label: '点灯後、@@秒経過で消灯', index: 2},
      {value: 3, label: 'LED点灯なし', index: 3}
    ],
    // 配信タイプマスタ : 配信設定対応
    DeliveryConfig: [
      {value: 0, label: '非対応', index: 1},
      {value: 1, label: '対応', index: 0},
    ],
    // 画面構成マスタ : 画面方向
    ScreenOrientation: [
      {value: 0, label: '横'},
      {value: 1, label: '縦'}
    ],
    // 画面構成マスタ : サービスタイプ
    ServiceType: [
      {value: 1, label: 'コミュニティサポート系'},
      {value: 2, label: 'hoam系'},
      {value: 3, label: 'マンション・ホテル系'},
      {value: 4, label: 'directサイネージ系'}
    ],
    // 固定画面IDマスタ : 画面遷移フラグ
    ButtonEnabled: [
      {value: true, label: '有効'},
      {value: false, label: '無効'}
    ],
  },



  /***************
   * 画面構成レイアウト
   */
  Layout: {
    // 角丸設定
    RoundCorner: [
      {value: 0, label: 'なし', index: 1},
      {value: 1, label: 'あり', index: 0}
    ],
    // ボタンレイアウトサイズ
    ButtonSize: [
      {value: 0, label: '小サイズ'},
      {value: 1, label: '大サイズ'}
    ],
    // テキスト配置設定
    TextAlignment: [
      {value: 1, label: '左寄せ'},
      {value: 2, label: '中央寄せ'},
      {value: 3, label: '右寄せ'}
    ],

    // **********
    // ヘッダ設定
    Header: {
      // ロゴ画像利用
      LogoImageUse: [
        {value: 0, label: '利用しない'},
        {value: 1, label: '利用する'}
      ],
      // 消灯ボタン利用
      LightOffButtonUse: [
        {value: 0, label: '利用しない'},
        {value: 1, label: '利用する'}
      ],
      // ボタンレイアウトタイプ
      ButtonLayoutType: [
        {value: 1, label: '正方形ボタンレイアウト'},
        {value: 2, label: '長方形ボタンレイアウト'}
      ],
    },

    Button: {
      LayoutType: [
        {value: 1, label: 'アイコン＋ラベル（上下）'},
        {value: 2, label: 'アイコン＋ラベル（左右）'},
        {value: 3, label: 'アイコンのみ'},
        {value: 4, label: 'ラベルのみ'}
      ]
    },
  },


  /***************
   * お知らせ管理
   */
  Notice: {
    // 一覧の表示タイプ
    ListType: [
      {value: 1, label: '配信済みお知らせ一覧'},
      {value: 2, label: '配信予約中お知らせ一覧'},
      {value: 3, label: '繰り返し配信お知らせ一覧'}
    ],
    // 配信済お知らせステータス
    DeliveryStatus: [
      {value: 2, label: '配信中'},
      {value: 4, label: '配信終了'},
      {value: 8, label: '配信停止'}
    ],
    // 予約配信ステータス
    ReservedNoticeStatus: [
      {value: 1, label: '配信前'},
    ],
    // 繰り返し配信お知らせステータス
    RepeatedNoticeStatus: [
      {value: 1, label: '配信予約中'},
      {value: 2, label: '配信中'},
    ],
    // 添付ファイル（画像）の最大登録数
    MaxImageFile: 10,
    // 添付ファイル（動画）の最大登録数
    MaxMovieFile: 1,
    // お知らせ配信計画タイプ
    DeliveryPlanType: [
      {value: 1, label: '即時配信'},
      {value: 2, label: '予約配信'},
      {value: 3, label: '繰り返し配信'}
    ],
    // 配信パターン
    DeliveryPattern: [
      {value: 1, label: '日曜', index: 6},
      {value: 2, label: '月曜', index: 0},
      {value: 4, label: '火曜', index: 1},
      {value: 8, label: '水曜', index: 2},
      {value: 16, label: '木曜', index: 3},
      {value: 32, label: '金曜', index: 4},
      {value: 64, label: '土曜', index: 5}
    ],
    // 警戒レベル
    KeikaiLevel: [
      {value: 0, label: '防災訓練'},
      {value: 1, label: '警戒レベル1（早期注意情報）'},
      {value: 2, label: '警戒レベル2（大雨・洪水・高潮注意報）'},
      {value: 3, label: '警戒レベル3（高齢者等避難）'},
      {value: 4, label: '警戒レベル4（避難指示）'},
      {value: 5, label: '警戒レベル5（緊急安全確保）'},
    ]
  },



  /***************
   * ログ管理
   */
  Log: {
    ResponseStatus: [
      {value: 0, label: '未対応'},
      {value: 1, label: '対応済'},
      {value: 2, label: '対応中'},
      {value: 3, label: '対応不要'}
    ],
    Service: [
      {value: 'active', label: '【ロケーション】 アクティブログ（ホーム画面表示）'},
      {value: 'use', label: '【ロケーション】 アクティブログ（画面表示・クリックログ）'},
      {value: 'stay', label: '【ロケーション】 滞在時間ログ'},
      {value: 'noticedelivery', label: '【ロケーション】 お知らせ配信ログ'},
      {value: 'enquetedelivery', label: '【ロケーション】 アンケート配信ログ'},
      {value: 'enqueteanswer', label: '【ロケーション】 アンケート回答ログ'},
      {value: 'pdfreading', label: '【ロケーション】 PDF閲覧ログ'},
      {value: 'spnoticedelivery', label: '【スマホアプリ】 お知らせ配信ログ'},
    ],
    OperatorService: [
      {value: 'active', label: '【ロケーション】 アクティブログ（ホーム画面表示）'},
      {value: 'use', label: '【ロケーション】 アクティブログ（画面表示・クリックログ）'},
      {value: 'noticedelivery', label: '【ロケーション】 お知らせ配信ログ'},
      {value: 'enquetedelivery', label: '【ロケーション】 アンケート配信ログ'},
      {value: 'enqueteanswer', label: '【ロケーション】 アンケート回答ログ'},
      {value: 'pdfreading', label: '【ロケーション】 PDF閲覧ログ'},
      {value: 'spnoticedelivery', label: '【スマホアプリ】 お知らせ配信ログ'},
    ],
    Analysis: [
      {value: 'analysisNonActiveDevices', label: '非稼働端末リスト'},
      {value: 'analysisLocationsUse', label: 'ロケーション利用集計'},
      {value: 'analysisNoticeDeliveries', label: 'お知らせ配信集計'},
      {value: 'spuse', label: 'スマホアプリ利用ログ集計'},
    ],
    VideoChat: [
      {value: 'videochatuse', label: '利用ログ'},
    ]
  },



  /***************
   * ADMP管理
   */
  Admp: {
    // ロケーションステータス
    LocationStatus: [
      {value: 0, label: '利用開始前'},
      {value: 1, label: '利用中'},
      {value: 2, label: '利用停止'}
    ]
  },



  /***************
   * ささえiでんわ管理
   */
  VideoChat: {
    // ステータス
    Status: [
      {value: 0, label: '利用開始前'},
      {value: 1, label: '利用中'},
      {value: 2, label: '利用停止'}
    ],
    // 電話帳表示・非表示設定
    Display: [
      {value: 0, label: '非表示'},
      {value: 1, label: '表示'},
    ],
    // お気に入りタブでの表示・非表示設定
    Favorite: [
      {value: 0, label: '非表示'},
      {value: 1, label: '表示'},
    ],
    // 属性
    Attribute: [
      {value: 1, label: '地区'},
      {value: 2, label: '町内会'},
      {value: 3, label: '小学校'},
      {value: 4, label: '中学校'}
    ]
  }
}
